import React from "react";
import "./MainPage.css";
import Navbar from "./Navbar";
import Mainbar from "./Mainbar";

const MainPage = () => {
  return (
    <div className="mt-1 mx-1 bg-[#F0F0E6] rounder-lg mainpage">
      <Navbar />
      <Mainbar />
    </div>
  );
};

export default MainPage;
